// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".soap-details td[data-v-00bc9320],.soap-details th[data-v-00bc9320]{padding:0!important;line-height:35px}.soap-details tr[data-v-00bc9320]{padding-left:1.5rem!important}", ""]);
// Exports
module.exports = exports;
